<template>
    <div class="userInfo">
        <h6 class="userInfo__name">{{ user.name }}</h6>
        <div v-if="user.isVerified" class="userInfo__verify">
            <img v-lazy-load src="/nuxt-assets/images/lazy-load-error.svg" data-src="/nuxt-assets/images/discussions/order-success.svg" />
            {{ $t('discussions.verifiedCustomer') }}
        </div>

        <div v-if="user.isPilulkaEmployee" class="userInfo__employment">
            {{ $t('discussions.pilulkaSpecialist') }}
        </div>
    </div>
</template>

<script lang="ts">
import { PropType } from 'vue'
import User from '~/models/Discussion/User'

export default {
    props: {
        user: {
            type: Object as PropType<User>,
            default: null,
            required: true,
        },
    },
}
</script>

<style lang="scss" scoped>
.userInfo {
    justify-self: flex-start;
    flex: 0 1 100%;
    margin-left: 1rem;

    @include screen-md {
        text-align: center;
        margin-left: 0;
        flex: 0 0 auto;
    }

    &__name {
        color: $color-dark;
        font-weight: bold;
        font-size: 14px;
        margin: 0;

        @include screen-md {
            margin-top: 1rem;
        }
    }

    &__employment {
        background: $color-cta-extra-light;
        color: $color-cta;
        padding: 0.25rem 0.5rem;
        font-size: 12px;
        border-radius: 50rem;
        margin-top: 5px;
        text-align: center;
        display: inline-block;
    }

    &__verify {
        color: $color-green-dark;
        display: flex;
        font-size: 12px;
        align-items: center;
        margin-top: 0.5rem;

        @include screen-md {
            margin-top: 1rem;
        }

        :deep(.order-success) {
            margin: 1.5px 5px;
        }

        img {
            margin-right: 5px;
            width: 14px;
            height: 14px;
        }
    }
}
</style>
